import { useEffect, useState } from 'react';
import MySelect, { components, MenuListProps } from 'react-select';
import { ReactComponent as PurpleCheck } from '../../assets/icons/purpleCheck.svg'
export const Select = ({ label, id, value, onChange, error, children, disable, name, selectPropRef, classes = "mb-4 w-full text-left", heights = "40px", icon = true }) => {
  const [childrens, setChildrens] = useState([]);
  const outputArray = childrens?.map(item => ({
    value: item?.props?.value,
    label: item?.props?.children
  }));
  useEffect(() => {
    setChildrens((children?.length > 1 && children[1]?.length) ? ([children[0], ...children[1]]) : children)
  }, [children])

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      height: 200,
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 200,
      overflowY: 'auto',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#e2e8f0' : '#F9FAFB', // Change background color when hovered
      color: state.isFocused ? 'black' : 'black',
      minHeight: heights,
      height: heights,
      display: 'flex',
      alignItems: 'center',
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: heights,
      padding: '0 6px',
      backgroundColor: '#F9FAFB',
      borderRadius: '8px',
    }),

    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: heights,
      backgroundColor: '#F9FAFB',
      borderRadius: '8px'
    }),
  };

  const customGetOptionLabel = (option) => (
    <div className='flex justify-between'>
      {option.label}
      {option.value !== "" && option.value === value && icon ? <div><PurpleCheck className='mt-1' /></div> : null} {/* Check mark for selected option */}
    </div>
  );

  const handleChange = (option) => {
    onChange({ target: { value: option?.value, name: name ?? "" } })
  }

  const customFilterOption = (outputArray, inputValue) => {
    const label = outputArray?.data?.label?.toLowerCase();
    const value = typeof (outputArray?.data?.value) === 'string' ? outputArray?.data?.value?.toLowerCase() : outputArray?.data?.value;
    const input = inputValue?.toLowerCase();

    // Return true if the label, value, or icon includes the input value
    return label?.includes(input) || value?.includes(input);
  };

  return (
    <div className={classes}>
      <label
        htmlFor={id}
        className={`${label ? "block" : "hidden"} mb-1 text-primary text-f14 font-semibold text-left`}
      >
        {label}
      </label>
      <MySelect id={id} name={name} ref={selectPropRef} getOptionLabel={customGetOptionLabel} styles={customStyles} filterOption={customFilterOption}
        value={outputArray?.find(option => option.value === value)} onChange={handleChange} isDisabled={disable} options={outputArray} />
      {error && <p className="text-red-500 text-sm text-left">{error}</p>}
    </div>
  );
};
